import { render, staticRenderFns } from "./IngredienteForm.vue?vue&type=template&id=dbff5c84&"
import script from "./IngredienteForm.vue?vue&type=script&lang=js&"
export * from "./IngredienteForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports